export const mirroredTasksEn = {
  taskCardMenuItem: 'Create a mirror',
  taskMirrorFailed: 'Mirror creation failed',
  taskMirrorSuccess: 'Mirror created successfully',
  mirrorsTitle: 'The task has mirrors:',
  taskMirrors: 'Task mirrors',
  disallowRepeatTask:
    "You can't turn a task mirror into a regular task. Duplicate the mirror and create a regular task from the duplicate."
}

export const mirroredTasksRu: typeof mirroredTasksEn = {
  taskCardMenuItem: 'Создать зеркало',
  taskMirrorFailed: 'Не удалось создать зеркало',
  taskMirrorSuccess: 'Зеркало успешно создано',
  mirrorsTitle: 'У задачи есть зеркала:',
  taskMirrors: 'Зеркала задачи',
  disallowRepeatTask:
    'Нельзя сделать регулярную задачу из зеркала. Сделайте дубль зеркала и из дубля создайте регулярную задачу.'
}
